import app, { Component } from 'apprun';
import { isValidElement, lookup_en } from '../utils';
import moment from 'moment';
export default class CommonPropertyComponent extends Component {

  state = { selectOptions: [] };

  view = (state) => {
    if (!state.item) {return;}
    return (
      <form id="frm-common-props-date-edit" class="form-horizontal" style={{ width: '450px' }} autocomplete="off">
        <div class="row">
          <div class="col-sm-12">{state.item.dispName}</div>
          {
            <div class="col-sm-12">
              <select id="inpText" class="form-control" oninput={e => state.chosenOption = e.target.value}>
                {
                  state.selectOptions.map(p => <option value={p.id} selected={p.id.toString().toUpperCase() === (state.chosenOption? state.chosenOption: '').toString().toUpperCase() ? 'selected' : null} >{p.value}</option>)
                }
              </select>
            </div>
          }
        </div>
        <div id="selectOptionsErrMsg" class="text-danger"></div>
        <div class="row">&nbsp;</div>
        <div class="row">
          <div class="col-sm-5">Start Date</div>
          <div class="col-sm-5">End Date</div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <input $pikaday id="startDateText" size="62" class="form-control" value={state.startDate} />
          </div>
          <div class="col-sm-5">
            <input $pikaday id="endDateText" size="62" class="form-control" value={state.endDate}/>
          </div>
        </div>

        <div class="row">
          <div id="startDateTextErrMsg" class="text-danger col-sm-5"></div>
          <div id="endDateTextErrMsg" class="text-danger col-sm-5" ></div>
        </div>
        <div class="row">
          <div id="dateTextErrMsg" class="text-danger col-sm-8"></div>
        </div>

        <div class="edit-buttons">
          <a type="button" class="btn btn-primary btn-xs" onclick={() => this.run('save')}>
            save
          </a>
          <a type="button" class="btn btn-primary btn-xs"
            style={(state.item.required || !state.item.value)?{ display:'none' }:{ display:'inline-block' }}
            onclick={() => state.caller.run(state.delete, state.item, state.panelId)}>
            delete
          </a>
          <a type="button" class="btn btn-default btn-xs" onclick={() => state.caller.run(state.cancel, state.panelId)}>
            cancel
          </a>
        </div>
      </form>
    );
  };

  update = {
    refresh: (state, newState) => {
      let selectOptions = [];
      if (newState.item.fieldTypeDetail && newState.item.fieldTypeDetail.startsWith('[')) {
        selectOptions = JSON.parse(newState.item.fieldTypeDetail);
      } else {
        selectOptions = lookup_en[newState.item.fieldTypeDetail];
      }
      selectOptions = selectOptions || [];
      selectOptions = selectOptions.filter(o => o.id !== 567 && o.id !== 568 && o.id !== 570 && o.id !== 573 && o.id !== 574 && o.id !== 576 );

      const speciality = JSON.parse(newState.item.value || '{"AttributeID":"","EffectiveDate":"","ExpirationDate":""}');

      return {
        ...state,
        ...newState,
        selectOptions,
        startDate: (speciality || {}).EffectiveDate && (speciality || {}).EffectiveDate !== '1900-01-01'
          ? moment((speciality || {}).EffectiveDate).format('DD-MMM-YYYY')
          : '',
        endDate: (speciality || {}).ExpirationDate && (speciality || {}).ExpirationDate !== '1900-01-01'
          ? moment((speciality || {}).ExpirationDate).format('DD-MMM-YYYY')
          : '',

        chosenOption: (speciality || {}).AttributeID,
        startDatePicker: null,
        endDatePicker: null,
      };
    },

    save: (state) => {
      document.getElementById('selectOptionsErrMsg').innerHTML = '';
      document.getElementById('startDateTextErrMsg').innerHTML = '';
      document.getElementById('endDateTextErrMsg').innerHTML = '';
      document.getElementById('dateTextErrMsg').innerHTML = '';

      state.startDate = (document.getElementById('startDateText') as HTMLInputElement).value;
      state.endDate = (document.getElementById('endDateText') as HTMLInputElement).value;

      let valid = true;

      //console.log('state');
      //console.log(state);

      if (state.chosenOption === '' || state.chosenOption === '-1') {
        valid = false;
        const errMsg = document.getElementById('selectOptionsErrMsg') as HTMLDivElement;
        errMsg.innerHTML = '* Please select a specialty.';
      }

      if(state.chosenOption !== '1121'){
        if (state.startDate === '') {
          valid = false;
          const errMsg = document.getElementById('startDateTextErrMsg') as HTMLDivElement;
          errMsg.innerHTML = '* Start date cannot be empty.';
        } else {
          valid = valid && isValidElement('startDateText', 'DateStr');
        }

        if (state.endDate === '') {
          valid = false;
          const errMsg = document.getElementById('endDateTextErrMsg') as HTMLDivElement;
          errMsg.innerHTML = '* End date cannot be empty.';
        } else {
          valid = valid && isValidElement('endDateText', 'DateStr');
        }

        if (valid && moment(state.startDate, 'DD-MMM-YYYY') > moment(state.endDate, 'DD-MMM-YYYY')) {
          valid = false;
          const errMsg = document.getElementById('dateTextErrMsg') as HTMLDivElement;
          errMsg.innerHTML = '* End date cannot be before Start date';
        }
      }
      if (valid) {
        state.newVal = JSON.stringify({
          AttributeID: state.chosenOption,
          EffectiveDate: state.startDate,
          ExpirationDate: state.endDate,
        });

        state.caller.run(state.save, state.item, state.panelId, state.newVal);
      }
    },
  };

  mounted = ({ state }) => {
    this.run('refresh', state);
  };
}
